import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import VueScrollTo from 'vue-scrollto'
import VueLazyload from 'vue-lazyload'
import PortalVue from 'portal-vue'
import '@/libs/primevue/index'
// @ts-ignore
import VueSocialauth from 'vue-social-auth'
// @ts-ignore
// import DisableAutocomplete from 'vue-disable-autocomplete'
import SocialiteConfig from '@/constants/social-config'
import i18n from '@/libs/i18n/index'
import router from './router'
import store from './store'
import App from './App.vue'
import GlobalFunctions from '@/libs/general-mixin'
// Global Components
import './global-components'

import './directives/check-permission-directive'
import './directives/check-business-type-directive'
import './directives/check-admin-permission-directive'
import './directives/bootstrap-toggle-directive'

// import '@/libs/acl'
import MomentPlugin from '@/plugins/moment-plugin'
import CurrencyPlugin from '@/plugins/currency-plugin'
import OkConfirmPlugin from '@/plugins/ok-confirm-plugin'
import '@/plugins/meta-plugin'
import '@/plugins/gtm-plugin'
// import 'default-passive-events'

import(/* webpackChunkName: "3rd-libs" */ '@/libs/portal-vue')
import(/* webpackChunkName: "3rd-libs" */ '@/libs/toastification')
import(/* webpackChunkName: "3rd-libs" */ '@/plugins/vue2-transitions')
import(/* webpackChunkName: "3rd-libs" */ '@/plugins/error-tracker-plugin')
import(/* webpackChunkName: "3rd-libs" */ '@/libs/tour')
import(/* webpackChunkName: "3rd-libs" */ '@/plugins/sweet-alert-plugin')

// Vue.use(DisableAutocomplete)
// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(MomentPlugin)
Vue.use(CurrencyPlugin)
Vue.use(OkConfirmPlugin)
Vue.mixin(GlobalFunctions)
Vue.use(VueScrollTo)
Vue.use(PortalVue)
Vue.use(VueSocialauth, SocialiteConfig)

const loadImage = require('./assets/images/lazy/loading.svg')
const errorImage = require('./assets/images/lazy/error.png')

Vue.use(VueLazyload, {
  error: errorImage,
  loading: loadImage,
  attempt: 1,
  observer: true,
})

// Composition API
Vue.use(VueCompositionAPI)

// Feather font icon - For form-wizard
// @ts-ignore
import(/* webpackChunkName: "feather" */ '@/assets/glyphicon/css/custom-icons.css') // For form-wizard
// @ts-ignore
import(/* webpackChunkName: "feather" */'@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

Vue.prototype.$bus = new Vue()

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
